<template>
  <div class="msg-container">
    <div class="msg-card-wrap">
      <div class="msg-card">
        <div class="top">
          <p class="number" v-text="msg.dragoncode"></p>
          <p class="name" v-text="msg.name"></p>
        </div>
        <div class="bottom">
          <div class="left">
            <p class="valid">Valid Till</p>
            <p class="date" v-text="msg.expiryDate">30 Sep 2019</p>
          </div>
          <div class="right">
            Total Available Visit(s)
            <strong v-text="msg.pointNum"></strong>
          </div>
        </div>
      </div>
    </div>
    <div class="qr-wrap">
      <p>Please present this lounge pass at the lounge for entry.</p>
      <div class="qr">
        <img :src="msg.qrcodeImg" alt />
      </div>
    </div>
    <div class="lounge">
      <p class="title">Access to 1000+ lounges worldwide.</p>
      <router-link class="btn" to="/airport">Find a lounge</router-link>
      <div class="form">
        <div class="form-inner">
          <p class="label">Lounge Pass Number</p>
          <p class="msg" v-text="msg.dragoncode"></p>
        </div>
        <div class="form-inner">
          <p class="label">Name as in Passport</p>
          <p class="msg" v-text="msg.name"></p>
        </div>
        <div class="form-inner">
          <p class="label">Total Available Visit</p>
          <p class="msg" v-text="msg.pointNum"></p>
        </div>
        <div class="form-inner">
          <p class="label">Expiry Date</p>
          <p class="msg" v-text="msg.expiryDate"></p>
        </div>
        <div class="form-inner">
          <p class="label">Issuer</p>
          <p class="msg">DragonPass</p>
        </div>
      </div>
    </div>
    <img class="footer" src="../assets/images/img-email-2@2x.png" alt />
  </div>
</template>

<script>
export default {
  name: "message",
  data() {
    return {
      msg: ""
    };
  },
  mounted() {
    console.log(this.$router.history.current.params.dragonCode);
    this.$axios
      .post(
        "/api/order/loungeCertificate/" +
          this.$router.history.current.params.dragonCode,
        {},
        {
          headers: {
            language: this.$i18n.locale
          }
        }
      )
      .then(res => {
        if (res.data.state === "11") {
          this.msg = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.msg-container {
  max-width: 550px;
  margin: 0 auto;
}
.msg-card-wrap {
  height: 220px;
  background: #7b8090;
  overflow: hidden;
}
.msg-card {
  width: 318px;
  height: 190px;
  background: url("/static/images/cardbg.png");
  background-size: 100% 100%;
  margin: 15px auto;
  position: relative;
}
.msg-card .top {
  position: absolute;
  bottom: 80px;
  left: 15px;
}
.msg-card .top .number {
  font-size: 18px;
  color: #666;
}
.msg-card .top .name {
  font-size: 14px;
  color: #333;
}
.msg-card .bottom {
  width: 100%;
  position: absolute;
  bottom: 20px;
  left: 0;
}
.msg-card .bottom .left {
  position: absolute;
  left: 15px;
  bottom: 0;
}
.msg-card .bottom .right {
  position: absolute;
  right: 15px;
  bottom: 0;
  font-size: 12px;
  color: #999;
}
.msg-card .bottom .valid {
  font-size: 12px;
  color: #999;
}
.msg-card .bottom .date {
  font-size: 13px;
  color: #333;
}
.msg-card .bottom .right strong {
  color: #333;
  font-size: 14px;
}
.qr-wrap {
  height: 220px;
  background: #ebecf1;
  overflow: hidden;
}
.qr-wrap p {
  font-size: 14px;
  color: #2d354d;
  margin: 20px 0;
  text-align: center;
}
.qr-wrap .qr {
  width: 138px;
  height: 138px;
  margin: 0 auto;
}
.qr-wrap .qr img {
  width: 100%;
  height: 100%;
}
.lounge {
  width: 80%;
  margin: 0 auto;
}
.lounge .title {
  font-size: 14px;
  color: #2d354d;
  text-align: center;
  margin: 20px 0;
}
.lounge .btn {
  display: block;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background: #910000;
  border-radius: 4px;
}
.lounge .form {
  border: 1px #ccc solid;
  border-radius: 4px;
  margin: 20px 0;
}
.lounge .form .form-inner {
  height: 60px;
  border-bottom: 1px #ccc solid;
  padding-left: 10px;
  overflow: hidden;
}
.lounge .form .form-inner:last-child {
  border-bottom: 0;
}
.lounge .form .label {
  font-size: 14px;
  color: #7b8191;
  margin: 10px 0 5px;
}
.lounge .form .msg {
  font-size: 14px;
  color: #333;
}
.footer {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Message.en.vue